import React from 'react'
import PropTypes from 'prop-types'

export const Toggler = ({
  id,
  label,
  toggleFlag,
  toggleHandler,
  disabled = false,
}) => {
  return (
    <div className="mb-2">
      <p className="mb-0">{label}</p>
      <div className="custom-control custom-switch" style={{ paddingLeft: 0 }}>
        <label className="open-beta--switch">
          <input
            id={id}
            data-testid={id}
            type="checkbox"
            value={toggleFlag}
            onClick={toggleHandler}
            checked={toggleFlag}
            disabled={disabled}
          />
          <span className="open-beta--slider open-beta--round" />
        </label>
      </div>
    </div>
  )
}

Toggler.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  toggleFlag: PropTypes.bool,
  toggleHandler: PropTypes.func,
  disabled: PropTypes.bool,
}
